const os = () => {
  const agent = navigator.userAgent.toLowerCase();

  if (agent.indexOf('windows') !== -1) return 'window';
  if (agent.indexOf('macintosh') !== -1) return 'macintosh';
};

export default os;
